<template>
  <div class="header">
    <div class="header-pc">
      <img class="placeholder-img" src="../assets/home/netbank.png" alt="网银互联" />
      <div class="header-main">
        <div class="menu-lfet">
          <div class="logo" @click="$router.push({ path: '/' })">
            <i style="font-size:56px;color:#fff" class="iconfont icon-logo-w-01"></i>
          </div>
          <ul class="menu" @mouseleave="menustyle = 'height:0px;'">
            <li v-for="(item, key) in navs" :key="key" class="itemtest" @mouseover="chShowIndex(key)">
              <div class="iteminner">
                <a :href="item.url" class="li">{{ item.name }}</a>
              </div>
              <div class="itemsubs" style>
                <div class="sub" v-for="(v, k) in item.dl" :key="k" :style="v.style">
                  <a :href="v.url" class="li">{{ v.dt }}</a>
                  <div class="submenu">
                    <div class="menuitem" v-for="(a, b) in v.dd" :key="b">
                      <a :href="a.url">{{ a.na }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="menu-expend" :style="menustyle">
            <div v-show="showindex === 0" @mouseleave="hiShowIndex" @mouseover="enterSubMenu(0)">
              <div class="menu-expend-main">
                <div class="menu-expend-left">
                  <div
                    class="left-item"
                    @mouseenter="
                      menuIndex = 4;
                      menuPos = 'top:126px';
                    "
                    :style="menuIndex == 4 ? 'color: #C3191F;' : ''"
                  >
                    <!-- <i class="iconfont icon-shujuzhongxin-01"></i> -->
                    <span class="brand" :style="menuIndex == 4 ? 'background: #C3191F;' : ''">GPU</span>
                    算力服务
                  </div>
                  <div
                    class="left-item"
                    @mouseenter="
                      menuIndex = 3;
                      menuPos = 'top:126px';
                    "
                    :style="menuIndex == 3 ? 'color: #C3191F;' : ''"
                  >
                    <!-- <i class="iconfont icon-shujuzhongxin-01"></i> -->
                    <span class="brand" :style="menuIndex == 3 ? 'background: #C3191F;' : ''">IDC</span>
                    IDC服务
                  </div>
                  <div
                    class="left-item"
                    @mouseenter="
                      menuIndex = 2;
                      menuPos = 'top:78px';
                    "
                    :style="menuIndex == 2 ? 'color: #C3191F;' : ''"
                  >
                    <!-- <i class="iconfont icon-yunjisuan"></i> -->
                    <span class="brand" :style="menuIndex == 2 ? 'background: #C3191F;' : ''">MDC</span>
                    网络融合服务
                  </div>
                  <div
                    class="left-item"
                    @mouseenter="
                      menuIndex = 1;
                      menuPos = 'top:30px';
                    "
                    :style="menuIndex == 1 ? 'color: #C3191F;' : ''"
                  >
                    <!-- <i class="iconfont icon-yunwangluo-"></i> -->
                    <span class="brand" :style="menuIndex == 1 ? 'background: #C3191F;' : ''">MDC</span>
                    其它服务
                  </div>

                  <div class="slidebar" :style="menuPos"></div>
                </div>
                <div class="menu-expend-right">
                  <div class="menu-expend-right-wrap" :style="menuIndex == 4 ? 'opacity: 1;z-index:99' : 'opacity: 0;'">
                    <div class="right-item" v-for="(item, key) in menuGroupG" :key="key">
                      <div class="item-tit">
                        <div class="icon">
                          <i :class="item.icon" :style="item.iconStyle"></i>
                        </div>
                        <div class="tit">{{ item.name }}</div>
                      </div>
                      <div class="item-subpages">
                        <a class="page" v-for="(subItem, subIndex) in item.subPages" :href="subItem.url">
                          {{ subItem.subName }}
                          <i
                            class="iconfont icon-HOT"
                            v-if="subItem.hot"
                            style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #ff973a;
                          "
                          ></i>
                          <i
                            class="iconfont icon-NEW-copy"
                            v-if="subItem.new"
                            style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #f72d2d;
                          "
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="menu-expend-right-wrap" :style="menuIndex == 1 ? 'opacity: 1;z-index:99' : 'opacity: 0;'">
                    <div class="right-item" v-for="(item, key) in menuGroupA" :key="key">
                      <div class="item-tit">
                        <div class="icon">
                          <i :class="item.icon" :style="item.iconStyle"></i>
                        </div>
                        <div class="tit">{{ item.name }}</div>
                      </div>
                      <div class="item-subpages">
                        <a class="page" v-for="(subItem, subIndex) in item.subPages" :href="subItem.url">
                          {{ subItem.subName }}
                          <i
                            class="iconfont icon-HOT"
                            v-if="subItem.hot"
                            style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #ff973a;
                          "
                          ></i>
                          <i
                            class="iconfont icon-NEW-copy"
                            v-if="subItem.new"
                            style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #f72d2d;
                          "
                          ></i>
                        </a>
                        <!-- <p
                        class="page"
                        v-for="(subItem, subIndex) in item.subPages"
                        @click="enter(subItem.url)"
                      >
                        {{ subItem.subName }}
                        <i
                          class="iconfont icon-HOT"
                          v-if="subItem.hot"
                          style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #ff973a;
                          "
                        ></i>
                        <i
                          class="iconfont icon-NEW-copy"
                          v-if="subItem.new"
                          style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #f72d2d;
                          "
                        ></i>
                        </p>-->
                      </div>
                    </div>
                  </div>
                  <div class="menu-expend-right-wrap" :style="menuIndex == 2 ? 'opacity: 1;z-index:99' : 'opacity: 0;'">
                    <div class="right-item" v-for="(item, key) in menuGroupB" :key="key">
                      <div class="item-tit">
                        <div class="icon">
                          <i :class="item.icon" :style="item.iconStyle"></i>
                        </div>
                        <div class="tit">{{ item.name }}</div>
                      </div>
                      <div class="item-subpages">
                        <a class="page" v-for="(subItem, subIndex) in item.subPages" :href="subItem.url">
                          {{ subItem.subName }}
                          <i
                            class="iconfont icon-HOT"
                            v-if="subItem.hot"
                            style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #ff973a;
                          "
                          ></i>
                          <i
                            class="iconfont icon-NEW-copy"
                            v-if="subItem.new"
                            style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #f72d2d;
                          "
                          ></i>
                        </a>
                        <!-- <p
                        class="page"
                        v-for="(subItem, subIndex) in item.subPages"
                        @click="enter(subItem.url)"
                      >
                        {{ subItem.subName }}
                        <i
                          class="iconfont icon-HOT"
                          v-if="subItem.hot"
                          style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #ff973a;
                          "
                        ></i>
                        <i
                          class="iconfont icon-NEW-copy"
                          v-if="subItem.new"
                          style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #f72d2d;
                          "
                        ></i
                      >

                        </p>-->
                      </div>
                    </div>
                  </div>
                  <div class="menu-expend-right-wrap" :style="menuIndex == 3 ? 'opacity: 1;z-index:99' : 'opacity: 0;'">
                    <div class="right-item" v-for="(item, key) in menuGroupC" :key="key">
                      <div class="item-tit">
                        <div class="icon">
                          <i :class="item.icon" :style="item.iconStyle"></i>
                        </div>
                        <div class="tit">{{ item.name }}</div>
                      </div>
                      <div class="item-subpages">
                        <a class="page" v-for="(subItem, subIndex) in item.subPages" :href="subItem.url">
                          {{ subItem.subName }}
                          <i
                            class="iconfont icon-HOT"
                            v-if="subItem.hot"
                            style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #ff973a;
                          "
                          ></i>
                          <i
                            class="iconfont icon-NEW-copy"
                            v-if="subItem.new"
                            style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #f72d2d;
                          "
                          ></i>
                        </a>
                        <!-- <p
                        class="page"
                        v-for="(subItem, subIndex) in item.subPages"
                        @click="enter(subItem.url)"
                      >
                        {{ subItem.subName }}
                        <i
                          class="iconfont icon-HOT"
                          v-if="subItem.hot"
                          style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #ff973a;
                          "
                        ></i>
                        <i
                          class="iconfont icon-NEW-copy"
                          v-if="subItem.new"
                          style="
                            font-size: 24px;
                            margin-left: 5px;
                            color: #f72d2d;
                          "
                        ></i>
                        </p>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="showindex === 1" @mouseleave="hiShowIndex" @mouseover="enterSubMenu(1)">
              <div class="menu-expend-main">
                <div class="menu-expend-left">
                  <div
                    class="left-item"
                    @mouseenter="
                      menuIndexx = 1;
                      menuPosx = 'top:30px';
                    "
                    :style="menuIndexx == 1 ? 'color: #C3191F;' : ''"
                    style="padding-left: 100px"
                  >
                    网络融合解决方案
                  </div>
                  <div
                    class="left-item"
                    @mouseenter="
                      menuIndexx = 2;
                      menuPosx = 'top:78px';
                    "
                    :style="menuIndexx == 2 ? 'color: #C3191F;' : ''"
                    style="padding-left: 100px"
                  >
                    IDC解决方案
                  </div>
                  <div
                    class="left-item"
                    @mouseenter="
                      menuIndexx = 3;
                      menuPosx = 'top:30px';
                    "
                    :style="menuIndexx == 3 ? 'color: #C3191F;' : ''"
                    style="padding-left: 100px"
                  >
                    算力服务解决方案
                  </div>
                  <div class="slidebar" :style="menuPosx"></div>
                </div>
                <div class="menu-expend-right">
                  <div class="menu-expend-right-wrap">
                    <div v-if="menuIndexx == 1" class="right-item" v-for="(item, key) in menuGroupE" :key="key">
                      <div class="item-tit">
                        <div class="icon">
                          <i :class="item.icon" :style="item.iconStyle"></i>
                        </div>
                        <div class="tit">{{ item.name }}</div>
                      </div>
                      <div class="item-subpages">
                        <a class="page" v-for="(subItem, subIndex) in item.subPages" :href="subItem.url">{{ subItem.subName }}</a>
                      </div>
                    </div>
                    <div v-if="menuIndexx == 2" class="right-item" v-for="(item, key) in menuGroupF" :key="key">
                      <div class="item-subpages" style="width:960px;display: flex;flex-wrap: wrap;">
                        <a class="page" style="width:200px;margin-bottom:10px" v-for="(subItem, subIndex) in item.subPages" :href="subItem.url">{{ subItem.subName }}</a>
                      </div>
                    </div>
                    <div v-if="menuIndexx == 3" class="right-item" v-for="(item, key) in menuGroupSolutionG" :key="key">
                      <div class="item-subpages" style="width:960px;display: flex;flex-wrap: wrap;">
                        <a class="page" style="width:200px;margin-bottom:10px" v-for="(subItem, subIndex) in item.subPages" :href="subItem.url">{{ subItem.subName }}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="menu-right">
          <div class="search">
            <el-select :style="theWidth" v-model="value" filterable ref="sel" placeholder="请输入关键字" @focus="expOrShr('expend')" @blur="expOrShr('shrink')" @change="linkTo">
              <el-option v-for="(item, index) in allPages" :key="index" :label="item.name" :value="item.url"></el-option>
            </el-select>
            <i class="after-icon el-icon-search"></i>
          </div>
          <div class="link">
            <!-- <div class="btn-text" @click="enter('/documents', true)">文档</div>| -->
            <!-- <div class="btn-text" @click="enter('/wanPartners', true)">商业合作</div> -->
            <div
              class="btn-solid"
              @click="
                open({
                  itemName: '欢迎咨询相关信息',
                  buType: 14,
                  items: ['job', 'introduction'],
                  exReq: ['job'],
                })
              "
            >
              咨询与试用
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-phone">
      <div class="header-main">
        <div class="header-logo" @click="$router.push({ path: '/' })">
          <svg class="icon" aria-hidden="true" style="width: 2.7rem">
            <use xlink:href="#iconcolorfulnetbank_huaban1" />
          </svg>
        </div>
        <div class="header-menu" @click="expand = !expand">
          <i class="iconfont mobicon-caidan" :style="expand ? 'transform: rotateZ(90deg);' : 'transform: rotateZ(0deg);'"></i>
        </div>
      </div>
      <div class="header-menumain" :style="expand ? 'right:0' : 'right:-7.5rem'">
        <div class="fir-item-wrap" v-for="(item, index) in mobMenu" :key="index + '1'">
          <div class="fir-item" @click="rootExp(index)">
            {{ item.name }}
            <div class="iconbox">
              <i :class="item.exp ? 'iconfont  mobicon-arrow-up' : 'iconfont  mobicon-icon-test'"></i>
            </div>
          </div>
          <div class="sec-item-wrap" v-for="(subitem, subindex) in item.subs">
            <div class="sec-item" :style="item.exp ? 'min-height:1.2rem' : 'height:0'" @click="subExp(index, subindex, subitem.subexp)">
              {{ subitem.subname }}
              <div v-if="subitem.subs.length" class="iconbox">
                <i :class="subitem.subexp ? 'iconfont  mobicon-arrow-up' : 'iconfont  mobicon-icon-test'"></i>
              </div>
            </div>
            <div class="thr-item-wrap">
              <div class="thr-item" v-for="(theitem, subindex) in subitem.subs" :style="subitem.subexp ? 'height:1.2rem' : 'height:0'" @click="enter(theitem.theurl)">{{ theitem.thename }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-mask" v-if="expand" @click="expand = !expand"></div>
    </div>
    <theForm ref="theForm"></theForm>
  </div>
</template>
<script>
import { routers } from "../router/router";
import theForm from "../components/form";
export default {
  components: { theForm },
  created() {
    let pageGroupA = this.getPages(this.menuGroupA);
    let pageGroupB = this.getPages(this.menuGroupB);
    let pageGroupC = this.getPages(this.menuGroupC);
    // let pageGroupD = this.getPages(this.menuGroupD)
    let pageGroupE = this.getPages(this.menuGroupE);
    let pageGroupF = this.getPages(this.menuGroupF);
    this.allPages = [...pageGroupA, ...pageGroupB, ...pageGroupC, ...pageGroupE, ...pageGroupF, ...this.navPages];
  },
  data() {
    return {
      value: "",
      theWidth: "width:160px",
      routers: routers,
      menustyle: "",
      showindex: 0,
      navs: [
        {
          name: "产品资源",
        },
        // {
        //   name: "网络产品与服务"
        // },
        // {
        //   name: "IT基础资源与服务"
        // },
        {
          name: "解决方案",
        },
        {
          name: "合作伙伴",
          show: false,
          url: "/partners",
          // show: false,
          // dl: [
          //   {
          //     dt: "网银互联合作伙伴",
          //     url: "/partners",
          //     style: "width:140px;height:40px;line-height: 40px;"

          //   },
          // ]
        },
        {
          name: "客户成功",
          show: false,
          url: "/cases",
        },

        {
          name: "关于网银",
          show: false,
          dl: [
            {
              dt: "企业介绍",
              url: "/about/Introduction",
            },
            {
              dt: "加入我们",
              url: "/about/Join",
            },
            {
              dt: "新闻中心",
              url: "/about/News",
            },
          ],
        },
        // {
        //   name: "文档",
        //   show: false,
        //   url: "/documents"
        // },
      ],
      navPages: [
        {
          name: "客户成功",
          url: "/cases",
        },
        {
          name: "网银互联合作伙伴",
          url: "/partners",
        },
        {
          name: "LinkWAN合作伙伴",
          url: "/wanPartners",
        },
        {
          name: "企业介绍",
          url: "/about/Introduction",
        },
        {
          name: "加入我们",
          url: "/about/Join",
        },
        {
          name: "新闻中心",
          url: "/about/News",
        },
      ],
      menuIndex: 1,
      menuPos: "top:30px",
      menuIndexx: 1,
      menuPosx: "top:30px",
      menuGroupA: [
        {
          name: "MDC | 其它服务",
          icon: "iconfont icon-yunguanli1",
          iconStyle: "font-size:20px",
          url: "",
          subPages: [
            {
              subName: "云服务",
              url: "/resource/CloudServices",
            },
            {
              subName: "云桌面",
              url: "/resource/Desktop",
              hot: true,
            },
            {
              subName: "云存储",
              url: "/resource/CloudStorage",
            },
            {
              subName: "云架构设计与迁移服务",
              url: "/resource/CloudMSP",
              hot: true,
            },
            {
              subName: "大数据技术",
              url: "/resource/BigData",
            },
            {
              subName: "数据容灾备份",
              url: "/resource/DisasterRecovery",
            },
          ],
        },
        // {
        //   name: "CIN | 云安全",
        //   icon: "iconfont icon-anquanfuwuguanli",
        //   iconStyle: "font-size:18px",
        //   url: "",
        //   subPages: [
        //     {
        //       subName: "等保测评服务",
        //       url: "/resource/SafetyRule",
        //       hot: true
        //     },
        //     {
        //       subName: "安全资源池",
        //       url: "/solution/SecurityPool"
        //     },
        //     {
        //       subName: "企业信息安全",
        //       url: "/resource/InfoSecurity"
        //     }
        //   ]
        // },
        // {
        //   name: "LinkCloud | 容器云",
        //   icon: "iconfont icon-rongqiyun",
        //   iconStyle: "font-size:25px",
        //   subPages: [
        //     {
        //       subName: "魔方云容器PaaS平台",
        //       url: "/resource/CubeCloud",
        //       new: true
        //     },

        //   ]
        // },
        {
          name: "ICT | 集成",
          icon: "iconfont icon-tuoguanyun",
          iconStyle: "font-size:25px",
          subPages: [
            {
              subName: "LinkCloud托管云平台",
              url: "/resource/CloudLinkCloud",
              new: true,
            },
          ],
        },
        // {
        //   name: "混合云",
        //   isHover: false,
        //   url: "/resource/HybridCloud"
        // },
        // {
        //   name: "云架构设计咨询和迁移",
        //   isHover: false,
        //   url: "/resource/CloudMSP"
        // },

        // {
        //   name: "等级保护安全",
        //   isHover: false,
        //   url: "/resource/SafetyRule"
        // },
        // {
        //   name: "企业信息安全",
        //   isHover: false,
        //   url: "/resource/InfoSecurity"
        // }
      ],
      menuGroupB: [
        // {
        //   name: "LinkWAN | SD-WAN",
        //   isHover: false,
        //   icon: "iconfont icon-SD-WAN",
        //   iconStyle: "font-size:22px",
        //   subPages: [
        //     {
        //       subName: "LinkWAN 全球组网",
        //       url: "/resource/Sdwan",
        //       hot: true
        //     },
        //     {
        //       subName: "LinkWAN 硬件设备",
        //       url: "/resource/WanEquipment",
        //       new: true
        //     },
        //     {
        //       subName: "企业跨境加速器",
        //       url: "/resource/WanAccelerator",
        //       new: true
        //     }
        //   ]
        // },
        {
          name: "MDC | 网络融合服务",
          isHover: false,
          icon: "iconfont icon-yunzhuanxian",
          iconStyle: "font-size:20px",
          url: "",
          subPages: [
            {
              subName: "云数据同步服务",
              url: "/resource/WanCCS",
            },
            {
              subName: "IDC数据同步服务",
              url: "/resource/WanDCS",
            },
          ],
        },
        {
          name: "MDC | 云网安全",
          isHover: false,
          icon: "iconfont icon-gongyouyunyunpan",
          iconStyle: "font-size:20px",
          url: "",
          subPages: [
            {
              subName: "等保测评服务",
              url: "/resource/SafetyRule",
              hot: true,
            },
            {
              subName: "安全资源池",
              url: "/solution/SecurityPool",
            },
            {
              subName: "企业信息安全",
              url: "/resource/InfoSecurity",
            },
          ],
        },

        // {
        //   name: "LinkWAN | SD-WAN",
        //   isHover: false,
        //   // src: require("../assets/header/iconb1.png"),
        //   // srch: require("../assets/header/iconb1h.png"),

        //   url: "/resource/Sdwan"
        // },
        // {
        //   name: "LinkWAN | CCS",
        //   isHover: false,
        //   // src: require("../assets/header/iconb2.png"),
        //   // srch: require("../assets/header/iconb2h.png"),
        //   url: "/resource/WanCCS"
        // },
        // {
        //   name: "LinkWAN | DCS",
        //   isHover: false,
        //   // src: require("../assets/header/iconb3.png"),
        //   // srch: require("../assets/header/iconb3h.png"),
        //   url: "/resource/WanDCS"
        // }
        // {
        //   name: "企业专线服务",
        //   isHover: false,
        //   src: require("../assets/header/iconb4.png"),
        //   srch: require("../assets/header/iconb4h.png"),
        //   url: ""
        // }
      ],
      menuGroupC: [
        {
          name: "IDC | 数据中心",
          icon: "iconfont icon-shujuzhongxin",
          iconStyle: "font-size:18px",
          subPages: [
            {
              subName: "浙西智算中心",
              url: "/resource/IdcJianDe",
              new: true,
            },
            {
              subName: "下沙数据中心",
              url: "/resource/IdcXiaSha",
              hot: true,
            },
            {
              subName: "福地数据中心",
              url: "/resource/IdcFudi",
              hot: true,
            },

            {
              subName: "杭钢数据中心",
              url: "/resource/MdcHG",
              new: true,
            },
            // {
            //   subName: "超算数据中心",
            //   url: "/resource/IdcSCDataCenter",
            //   new: true
            // },
          ],
        },
        {
          name: "IDC | 服务模式",
          icon: "iconfont icon-fuwumoshi",
          iconStyle: "font-size:24px",
          subPages: [
            {
              subName: "标准机柜模式",
              url: "/resource/IdcServiceModels",
            },
            {
              subName: "定制化模块服务",
              url: "/resource/IdcServiceModels",
            },
            {
              subName: "整体数据中心建设",
              url: "/resource/IdcServiceModels",
            },
          ],
        },
        {
          name: "IDC | 数据中心运维",
          icon: "iconfont icon-yunwei",
          iconStyle: "font-size:24px",
          subPages: [
            {
              subName: "数据中心运营管理",
              url: "/resource/IdcCoop",
            },
            {
              subName: "标准服务",
              url: "/resource/IdcStaVaServices",
            },
            {
              subName: "增值服务",
              url: "/resource/IdcStaVaServices",
            },
          ],
        },
      ],
      // 解决方案
      // menuGroupD: [
      //   {
      //     name: "容器混合云解决方案",
      //     isHover: false,
      //     src: "",
      //     srch: "",
      //     url: "/solution/ConAndMix"
      //   },
      //   {
      //     name: "容器化解决方案",
      //     isHover: false,
      //     src: "",
      //     srch: "",
      //     url: "/solution/Containerization"
      //   },
      //   {
      //     name: "容器DevOps解决方案",
      //     isHover: false,
      //     src: "",
      //     srch: "",
      //     url: "/solution/DevOps"
      //   },

      //   // A
      //   // B

      //   {
      //     name: "SaaS解决方案",
      //     isHover: false,
      //     src: "",
      //     srch: "",
      //     url: "/solution/SaaS"
      //   },
      //   {
      //     name: "上云及多云互联解决方案",
      //     isHover: false,
      //     src: "",
      //     srch: "",
      //     url: "/solution/ToCloud"
      //   },
      //   {
      //     name: "企业组网解决方案",
      //     isHover: false,
      //     src: "",
      //     srch: "",
      //     url: "/solution/CombinNet"
      //   },
      //   {
      //     name: "边缘计算解决方案",
      //     isHover: false,
      //     src: "",
      //     srch: "",
      //     url: "/solution/InternetoF"
      //   },

      //   {
      //     name: "新一代数据仓库解决方案",
      //     isHover: false,
      //     src: "",
      //     srch: "",
      //     url: "/solution/database"
      //   },
      //   {
      //     name: "云网融合解决方案",
      //     isHover: false,
      //     src: "",
      //     srch: "",
      //     url: "/solution/cloudAndNet"
      //   },
      //   {
      //     name: "企业安全解决方案",
      //     isHover: false,
      //     src: "",
      //     srch: "",
      //     url: "/solution/entSecurity"
      //   }

      //   // C
      // ],
      menuGroupE: [
        {
          name: "NaaS解决方案",
          icon: "",
          iconStyle: "",
          subPages: [
            // {
            //   subName: "分支组网解决方案",
            //   url: "/solution/BranchNetWork"
            // },
            // {
            //   subName: "SaaS应用加速解决方案",
            //   url: "/solution/SaaSApp"
            // },
            {
              subName: "上云及多云互联解决方案",
              url: "/solution/UpToCloud",
            },
            // {
            //   subName: "企业跨境组网解决方案",
            //   url: "/solution/CombinNet"
            // },
            {
              subName: "边缘计算解决方案",
              url: "/solution/InternetoF",
            },
          ],
        },
        // {
        //   name: "云原生解决方案",
        //   icon: "",
        //   iconStyle: "",
        //   subPages: [
        //     {
        //       subName: "容器混合云解决方案",
        //       url: "/solution/ConAndMix"
        //     },
        //     {
        //       subName: "容器化解决方案",
        //       url: "/solution/Containerization"
        //     },
        //     {
        //       subName: "容器DevOps解决方案",
        //       url: "/solution/DevOps"
        //     }
        //   ]
        // },
        {
          name: "Cloud MSP 解决方案",
          icon: "",
          iconStyle: "",
          subPages: [
            {
              subName: "新一代数据仓库解决方案",
              url: "/solution/database",
            },
            {
              subName: "企业安全解决方案",
              url: "/solution/entSecurity",
            },
          ],
        },
        {
          name: "其他解决方案",
          icon: "",
          iconStyle: "",
          subPages: [
            // {
            //   subName: "云网融合解决方案",
            //   url: "/solution/cloudAndNet"
            // },
            {
              subName: "等保测评解决方案",
              url: "/solution/equalGuarantee",
            },
            // {
            //   subName: "区块链/IPFS解决方案",
            //   url: "/solution/Blockchain"
            // }
          ],
        },
      ],
      menuGroupF: [
        {
          name: "行业解决方案",
          icon: "",
          iconStyle: "",
          subPages: [
            {
              subName: "数据中心定制解决方案",
              url: "/solution/dataCenter",
            },
            {
              subName: "机房搬迁服务解决方案",
              url: "/solution/DCmove",
            },
            {
              subName: "全方位运维服务解决方案",
              url: "/solution/maintenanceService",
            },

            // {
            //   subName: "跨境电商解决方案",
            //   url: "/solution/Ecommerce"
            // },
          ],
        },
      ],
      menuGroupG: [
        {
          name: "GPU | 算力服务",
          icon: "iconfont icon-shujuzhongxin",
          iconStyle: "font-size:18px",
          subPages: [
            {
              subName: "算力服务",
              url: "/resource/ComputePower",
              new: true,
            },
          ],
        },
      ],
      menuGroupSolutionG: [
        {
          name: "算力服务解决",
          icon: "iconfont icon-shujuzhongxin",
          iconStyle: "font-size:18px",
          subPages: [
            {
              subName: "算力服务解决方案",
              url: "/solution/ComputePower",
              new: true,
            },
          ],
        },
      ],
      menuGroupNetBankPartner: [
        {
          name: "网银互联合作伙伴",
          icon: "",
          iconStyle: "",
          subPages: [
            {
              subName: "网银互联合作伙伴",
              url: "/partners",
            },
          ],
        },
      ],
      // menuGroupLinkWanPartner: [
      //   {
      //     name: "合作伙伴架构",
      //     icon: "",
      //     iconStyle: "",
      //     subPages: [
      //       {
      //         subName: "商业伙伴",
      //         url: "/linkWanPartnerArc?tab=commerce",
      //         // new: true
      //       },
      //       {
      //         subName: "行业方案伙伴",
      //         url: "/linkWanPartnerArc?tab=industry",
      //         new: true
      //       },
      //       {
      //         subName: "资源战略伙伴",
      //         url: "/linkWanPartnerArc?tab=resource",
      //       },
      //       {
      //         subName: "合作伙伴权益",
      //         url: "/linkWanPartnerArc?tab=rai",
      //       },

      //     ]
      //   },
      //   {
      //     name: "合作伙伴政策",
      //     icon: "",
      //     iconStyle: "",
      //     subPages: [
      //       {
      //         subName: "产品销售差价",
      //         url: "/linkWanPartnerPol?tab=profit",
      //       },
      //       {
      //         subName: "价格阶梯激励",
      //         url: "/linkWanPartnerPol?tab=excitation",
      //         // new: true
      //       },
      //       {
      //         subName: "目标达成返点奖励",
      //         url: "/linkWanPartnerPol?tab=target",
      //       },

      //     ]
      //   },
      //   {
      //     name: "合作伙伴支持",
      //     icon: "",
      //     iconStyle: "",
      //     subPages: [
      //       {
      //         subName: "业务能力培养",
      //         url: "/linkWanPartnerSup?tab=business",
      //         new: true
      //       },
      //       {
      //         subName: "市场资源支持",
      //         url: "/linkWanPartnerSup?tab=talents",

      //       },
      //       {
      //         subName: "人才培养",
      //         url: "/linkWanPartnerSup?tab=market",
      //       },
      //       {
      //         subName: "技术支持",
      //         url: "/linkWanPartnerSup?tab=process",
      //       },

      //     ]
      //   },

      // ],
      allPages: [],
      // mobel data
      expand: false,
      mobMenu: [
        {
          name: "GPU算力服务",
          url: "",
          exp: false,
          subs: [
            {
              subname: "算力服务",
              url: "/resource/ComputePower",
              subexp: false,
              subs: [],
            },
          ],
        },
        {
          name: "IDC服务",
          url: "",
          exp: false,
          subs: [
            {
              subname: "IDC数据中心",
              url: "",
              subexp: false,
              subs: [
                {
                  thename: "数据中心",
                  theurl: "/mobResource/mdcDataCenter",
                },
                {
                  thename: "杭钢云数据中心",
                  theurl: "/mobResource/mdcHangGang",
                },
                // {
                //   thename: "超算数据中心",
                //   theurl: "/mobResource/mdcSCDataCenter"
                // },
              ],
            },
            {
              subname: "服务模式",
              url: "/mobResource/mdcServiceModels",
              subexp: false,
              subs: [
                // {
                //   thename: "服务模式",
                //   theurl: "/mobResource/mdcServiceModels"
                // }
              ],
            },
            {
              subname: "数据中心运维",
              url: "",
              subexp: false,
              subs: [
                {
                  thename: "数据中心运营管理",
                  theurl: "/mobResource/mdcCoop",
                },
                {
                  thename: "标准 / 增值服务",
                  theurl: "/mobResource/mdcStaVaServices",
                },
              ],
            },
          ],
        },
        {
          name: "MDC网络融合服务",
          url: "",
          exp: false,
          subs: [
            // {
            //   subname: "全球组网",
            //   url: "/mobResource/netSDWAN",
            //   subexp: false,
            //   subs: [
            //     // {
            //     //   thename: "SD-WAN",
            //     //   theurl: "/mobResource/netSDWAN"
            //     // }
            //   ]
            // },
            // {
            //   subname: "硬件设备",
            //   url: "/resource/WanEquipment",
            //   subexp: false,
            //   subs: []
            // },
            {
              subname: "IDC数据同步服务",
              url: "/mobResource/netDCS",
              subexp: false,
              subs: [
                // {
                //   thename: "DCS",
                //   theurl: "/mobResource/netSDWAN"
                // }
              ],
            },
            {
              subname: "云数据同步服务",
              url: "/mobResource/netCCS",
              subexp: false,
              subs: [
                // {
                //   thename: "CCS",
                //   theurl: "/mobResource/netCCS"
                // }
              ],
            },
            {
              subname: "云网安全",
              subexp: false,
              url: "",
              subs: [
                {
                  thename: "等保服务",
                  theurl: "/mobResource/cloudSafetyRule",
                },
                {
                  thename: "安全资源池",
                  theurl: "/mobResource/cloudSecurityPool",
                },
                {
                  thename: "企业信息安全",
                  theurl: "/mobResource/cloudInfoSecurity",
                },
              ],
            },
          ],
        },
        {
          name: "其它服务",
          exp: false,
          subs: [
            {
              subname: "云MSP",
              subexp: false,
              url: "",
              subs: [
                {
                  thename: "云服务",
                  theurl: "/mobResource/cloudService",
                },
                {
                  thename: "云桌面",
                  theurl: "/mobResource/cloudDesktop",
                },
                {
                  thename: "分布式存储",
                  theurl: "/mobResource/cloudStorage",
                },
                {
                  thename: "云架构设计与迁移",
                  theurl: "/mobResource/cloudMSP",
                },
                {
                  thename: "大数据技术",
                  theurl: "/mobResource/cloudBigData",
                },
                {
                  thename: "数据容灾备份",
                  theurl: "/mobResource/cloudRecovery",
                },
              ],
            },
            // {
            //   subname: "容器云",
            //   subexp: false,
            //   url: "",
            //   subs: [
            //     {
            //       thename: "容器云PaaS平台",
            //       theurl: "/mobResource/cloudPass"
            //     }
            //   ]
            // },
            {
              subname: "托管云",
              subexp: false,
              url: "",
              subs: [
                {
                  thename: "LinkCloud托管云平台",
                  theurl: "/mobResource/cloudLinkCloud",
                },
              ],
            },
          ],
        },
        {
          name: "解决方案",
          url: "",
          exp: false,
          subs: [
            {
              subname: "网络融合解决方案",
              url: "",
              subexp: false,
              subs: [
                // {
                //   thename: "分支组网解决方案",
                //   theurl: "/mobResource/solBranchNetWork"
                // },
                // {
                //   thename: "SaaS应用加速解决方案",
                //   theurl: "/mobResource/solSaaSApp"
                // },
                {
                  thename: "上云及多云互联解决方案",
                  theurl: "/mobResource/solUpToCloud",
                },
                {
                  thename: "边缘计算解决方案",
                  theurl: "/mobResource/solCalculate",
                },
                {
                  thename: "等保测评解决方案",
                  theurl: "/mobResource/MobEqualGuarantee",
                },
              ],
            },

            {
              subname: "IDC解决方案",
              url: "",
              subexp: false,
              subs: [
                {
                  thename: "全方位运维服务解决方案",
                  theurl: "/mobResource/DCmaintenance",
                },
                {
                  thename: "机房搬迁服务解决方案",
                  theurl: "/mobResource/DCmove",
                },
                {
                  thename: "数据中心定制解决方案",
                  theurl: "/mobResource/DCcustomized",
                },
              ],
            },
            {
              subname: "算力服务解决方案",
              url: "",
              subexp: false,
              subs: [
                {
                  thename: "算力服务解决方案",
                  theurl: "/solution/ComputePower",
                },
              ],
            },
          ],
        },
        {
          name: "关于网银",
          url: "",
          exp: false,
          subs: [
            {
              subname: "公司介绍",
              url: "/mobResource/MobIntroduction",
              subexp: false,
              subs: [],
            },
            {
              subname: "加入我们",
              url: "/mobResource/MobJoin",
              subexp: false,
              subs: [],
            },
          ],
        },
      ],
    };
  },
  methods: {
    open(data) {
      this.$refs.theForm.open(data);
    },
    enter(url, isblank) {
      if (url) {
        let a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("id", "startTelMedicine");
        if (isblank) a.setAttribute("target", "_blank");
        // 防止反复添加
        if (document.getElementById("startTelMedicine")) {
          document.body.removeChild(document.getElementById("startTelMedicine"));
        }
        document.body.appendChild(a);
        a.click();
      }
    },
    chShowIndex(key) {
      this.showindex = key;
      if (key == 0) {
        this.menustyle = "height:400px;";
      } else if (key == 1) {
        this.menustyle = "height:400px;";
      }
      // else if (key == 2) {
      //   this.menustyle = "height:400px;";
      // }
      else {
        this.menustyle = "height:0px;";
      }
    },
    hiShowIndex(key) {
      this.menustyle = "height:0px;";
      $("ul li:eq(0) .iteminner").removeClass("menuactive");
      $("ul li:eq(1) .iteminner").removeClass("menuactive");
      $("ul li:eq(2) .iteminner").removeClass("menuactive");
      $("ul li:eq(3) .iteminner").removeClass("menuactive");
    },
    enterSubMenu(key) {
      if (key == 0) {
        this.menustyle = "height:400px;";
        $("ul li:eq(0) .iteminner").addClass("menuactive");
      } else if (key == 1) {
        this.menustyle = "height:400px;";
        $("ul li:eq(1) .iteminner").addClass("menuactive");
      }
      // else if (key == 2) {
      //   this.menustyle = "height:400px;";
      //   $("ul li:eq(2) .iteminner").addClass("menuactive");
      // }
    },
    rootExp(index) {
      if (this.mobMenu[index].exp) {
        this.mobMenu[index].exp = false;
        this.mobMenu[index].subs.forEach((element) => {
          element.subexp = false;
        });
      } else {
        this.mobMenu[index].exp = true;
      }
    },
    subExp(index, subindex) {
      if (this.mobMenu[index].subs[subindex].url) {
        this.enter(this.mobMenu[index].subs[subindex].url);
      } else {
        this.mobMenu[index].subs[subindex].subexp = !this.mobMenu[index].subs[subindex].subexp;
      }
      // console.log(this.mobMenu[index].subs[subindex])
      // subitem.subexp = !subitem.subexp
    },
    getPages(pageGroup) {
      let newPageGroup = [];
      pageGroup.forEach((item) => {
        if (item.subPages) {
          item.subPages.forEach((subItem) => {
            let temp = {
              name: subItem.subName,
              url: subItem.url,
            };
            newPageGroup.push(temp);
          });
        } else {
          let temp = {
            name: item.name,
            url: item.url,
          };
          newPageGroup.push(temp);
        }
      });
      return newPageGroup;
    },
    expOrShr(act) {
      if (act === "expend") this.theWidth = "width:220px";
      else if (act === "shrink") this.theWidth = "width:160px";
    },
    linkTo(url) {
      this.value = "";
      this.enter(url, true);
    },
  },
};
</script>
<style lang="less" scoped>
@import "../style/variable.less";
@import "../style/animate.less";
@media screen and(min-width:@sm_min) {
  .header-pc {
    height: 80px;
    width: 100%;
    min-width: 1200px;
    position: absolute;
    z-index: 1;
    top: 0;
    z-index: 99;
    font-weight: 300;
    transition: all 0.3s;
    // background-color: rgba(0, 0, 0, 0.7);
    background-color: #262222;
    .placeholder-img {
      position: absolute;
      left: -100px;
      width: 100px;
    }

    .header-main {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .menu-lfet {
        display: flex;
        .logo {
          cursor: pointer;
          width: 175px;
          height: 80px;
          display: flex;
          display: -webkit-flex;
          align-items: center;
        }
        .slogen {
          float: right;
          height: 70px;
          padding-top: 18px;
          padding-right: 20px;
          img {
            width: 200px;
          }
        }
        .menu {
          width: fit-content;
          height: 100%;
          float: left;

          .itemtest {
            float: left;
            width: fit-content;
            height: 100%;
            position: relative;
            .iteminner {
              width: fit-content;
              padding: 0 20px;
              height: 100%;
              box-sizing: border-box;
              text-align: center;
              line-height: 80px;
              margin: 0 auto;
              -webkit-transition: all 0.3s;
              -moz-transition: all 0.3s;
              -o-transition: all 0.3s;
              transition: all 0.3s;
              .li {
                color: #fff;
                font-size: 14px;
                transition: 0.3s;
              }
              &:hover {
                a {
                  color: #f72d2d;
                }
              }
            }

            .iteminner:hover + .itemsubs {
              display: block;
            }

            .itemsubs:hover {
              display: block;
            }

            .itemsubs {
              background-color: #fff;
              height: 120 px;
              position: absolute;
              left: -10px;
              z-index: 99;
              display: none;
              -webkit-transition: all 0.3s;
              transition: all 0.3s;
              box-shadow: 0px 0px 8px 0px rgba(223, 209, 209, 0.36);

              .sub {
                height: 30px;
                width: 120px;
                margin: 10px 0;
                line-height: 30px;
                text-align: center;
                -webkit-transition: all 0.3s;
                transition: all 0.3s;
                position: relative;
                a {
                  transition: 0.3s;
                }
                &:hover {
                  // color: #b81c22;
                  a {
                    color: #c3191f;
                  }

                  // background-color: rgba(0, 0, 0, 0.2);
                }
              }

              .submenu {
                position: absolute;
                top: 0;
                left: 100px;
                display: none;
                width: 110px;
                background: #777;

                .menuitem {
                  height: 40px;
                  line-height: 40px;
                  a {
                    color: #fff;
                  }
                }
                .menuitem:hover {
                  a {
                    font-weight: 600;
                    color: #e62a39;
                  }
                }
              }
              .submax {
                // width: 600px;
                position: absolute;
                top: 0;
                left: 100px;
                display: none;
                color: #fff;
                background: rgba(51, 42, 42, 0.6);

                .maxitem {
                  padding-top: 10px;
                  width: 200px;
                  float: left;
                  margin-bottom: 10px;
                  color: #fff;
                  .maxtit {
                    width: 130px;
                    font-size: 16px;
                    line-height: 30px;
                    border-bottom: 1px solid rgba(202, 202, 202, 0.4);
                    margin: 0 auto;
                    box-sizing: border-box;
                  }
                  .maxwrap {
                    font-size: 14px;
                    line-height: 30px;
                    margin-top: 5px;
                  }
                  .maxwrap:hover {
                    a {
                      font-weight: bold;
                      color: #e62a39;
                    }
                  }
                }
              }
            }
          }

          .itemtest:nth-of-type(1):hover,
          .itemtest:nth-of-type(2):hover {
            cursor: default;
            .iteminner {
              &:after {
                content: "";
                position: absolute;
                bottom: 0;
                left: 50%;
                right: auto;
                -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
                width: 0;
                height: 0;
                border-left: 15px solid transparent;
                border-right: 15px solid transparent;
                border-bottom: 8px solid #fff;
              }
            }
          }
          .itemtest:nth-of-type(6):hover {
            cursor: default;
          }
        }
        .menu-expend {
          position: absolute;
          left: 0;
          top: 80px;
          height: 0px;
          width: 100%;
          color: #333;
          background-color: #fff;
          transition: all 0.3s;
          overflow: hidden;
          box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
          z-index: 999;
          .menu-expend-main {
            width: 1200px;
            height: 380px;
            margin: 0 auto;
            display: flex;
            display: -webkit-flex;
            .menu-expend-left {
              width: 260px;
              height: 100%;
              padding: 30px 20px 0 0;
              position: relative;
              &:before {
                content: "";
                width: 1px;
                height: 300px;
                background: #dfe1e6;
                position: absolute;
                top: 30px;
                right: 0;
              }
              // background: #000;
              .left-item {
                width: 250px;
                padding: 10px;
                font-size: 16px;
                cursor: pointer;
                transition: all 0.3s;
                position: relative;
                margin-bottom: 10px;
                line-height: 20px;
                transition: 0.3s;
                display: flex;
                display: -webkit-flex;
                align-items: center;
                &:before {
                  content: "";
                  // display: none;
                  width: 0px;
                  height: 2px;
                  background: #c3191f;
                  position: absolute;
                  left: -1px;
                  bottom: 0px;
                  transition: width 0.5s;
                }
                &:hover {
                  // color: #c3191f;
                  .brand {
                    background: #c3191f;
                  }
                }
                .brand {
                  width: 80px;
                  background: #ccc;
                  color: #fff;
                  display: inline-block;
                  height: 20px;
                  line-height: 20px;
                  border-radius: 3px;
                  text-align: center;
                  margin-right: 8px;
                  font-size: 12px;
                  transition: 0.3s;
                }
              }
              .active {
                &:before {
                  display: block;
                  height: 2px;
                  width: 99%;
                }
              }

              .slidebar {
                width: 3px;
                height: 38px;
                position: absolute;
                top: 30px;
                right: -1px;
                background: #c31b20;
                transition: 0.3s;
              }
            }
            .menu-expend-right {
              width: 960px;
              position: relative;

              .menu-expend-right-wrap {
                padding: 30px 0 30px 20px;
                background: #fff;
                transition: 0.5s;
                position: absolute;
                display: -webkit-flex;
                display: flex;
                flex-wrap: wrap;
                .right-item {
                  width: 226px;
                  color: #333;
                  margin-bottom: 35px;
                  .item-tit {
                    width: 180px;
                    display: -webkit-flex;
                    display: flex;
                    .icon {
                      width: 40px;
                      height: 40px;
                      display: -webkit-flex;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    }
                    .tit {
                      width: 140px;
                      line-height: 40px;
                      border-bottom: 1px solid rgba(161, 166, 171, 0.2);
                    }
                  }
                  .item-subpages {
                    width: 210px;
                    .page {
                      color: #999;
                      line-height: 45px;
                      padding-left: 40px;
                      cursor: pointer;
                      transition: 0.3s;
                      &:hover {
                        color: #c3191f;
                      }
                      display: flex;
                      display: -webkit-flex;
                      align-items: center;
                    }
                  }
                }
              }
            }
          }

          .items_box {
            display: -webkit-flex; /* Safari */
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            width: 1200px;
            margin: 0 auto;
            padding: 50px 0px 20px 0px;

            .item {
              width: 200px;
              height: 40px;
              padding-left: 18px;
              line-height: 40px;
              margin-right: 80px;
              margin-bottom: 25px;
              // border-radius: 3px;
              color: #333;
              cursor: pointer;
              transition: all 0.3s;
              border: 1px solid #fff;
              &:hover {
                color: #c3191f;
                border: 1px solid #c3191f;
                // background:#;
              }
            }
            .item:nth-child(4n) {
              margin-right: 0px;
            }
          }
          // overflow: hidden;
          .menu_items {
          }
        }
      }
      .menu-right {
        height: 80px;
        width: 470px;
        display: flex;
        align-items: center;
        .search {
          width: 220px;
          margin-right: 10px;
          .after-icon {
            color: #fff;
            font-size: 16px;
            position: absolute;
            top: 50%;
            transform: all 0.5s;
            transform: translate(-30px, -50%);
          }
        }
        .link {
          display: flex;
          align-items: center;
          color: #fff;
          .btn-text {
            cursor: pointer;
            padding: 10px;
            transition: all 0.3s;
            &:hover {
              color: #f72d2d;
            }
          }
          .btn-solid {
            cursor: pointer;
            margin-left: 20px;
            background: #c3191f;
            padding: 8px;
            border-radius: 6px;
          }
        }
      }
    }
    .menuactive {
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        right: auto;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 8px solid #fff;
      }
    }
  }
  .header-phone {
    display: none;
  }
}
@media screen and (min-width: @phone) and (max-width: @xs) {
  .header-phone {
    .header-main {
      width: 100%;
      height: 1.2rem;
      padding: 0 0.66rem;
      background: #121212;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      .header-logo {
        width: 2.67rem;
        height: 0.72rem;
        position: relative;
        .icon {
          position: absolute;
          top: 50%;
          transform: translateY(-49%);
        }
      }
      .header-menu {
        height: 0.54rem;
        width: 0.54rem;
        color: #fff;
        i {
          font-size: 0.54rem;
          transition: 0.3s;
          display: inline-block;
          // transform: rotateX(100deg);
        }
      }
    }
    .header-menumain {
      width: 7.5rem;
      height: 100%;
      background: #1d1d1d;
      transition: 0.3s;
      position: absolute;
      top: 1.2rem;
      z-index: 2000;

      .fir-item-wrap {
        .fir-item {
          color: #fff;
          font-size: 0.4rem;
          background: #1d1d1d;
          padding: 0 0.5rem;
          height: 1.2rem;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #606060;
          position: relative;
        }
        .sec-item-wrap {
          .sec-item {
            color: #b3b3b3;
            font-size: 0.36rem;
            overflow: hidden;
            padding: 0 0.8rem;

            display: flex;
            align-items: center;
            position: relative;
            // background: #ccc;
          }
          .thr-item-wrap {
            .thr-item {
              color: #b3b3b3;
              overflow: hidden;
              padding: 0 1.1rem;
              display: flex;
              align-items: center;
              background: #262626;
            }
          }
        }
      }
      .iconbox {
        height: 0.5rem;
        width: 0.5rem;
        // background: #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0.2rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .menu-mask {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      position: absolute;
      top: 1.2rem;
      left: 0;
      z-index: 99;
    }
  }

  .header-pc {
    display: none;
  }
}

/deep/.el-input__inner {
  background: #494141 !important;
  border: none !important;
  color: #e1e1e1 !important;
}

/deep/.el-select {
  transition: all 0.3s;
}
/deep/.el-input__icon {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue